import { useTranslation } from 'react-i18next';

import { Bolt } from '@unified-checkout/design-system/icons/index';

import styles from './banner.module.scss';

const Banner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles['instant-settlement__banner']}>
      {Bolt}
      <div className={styles['instant-settlement__banner-content']}>
        <p className={styles['instant-settlement__banner-content-title']}>
          {t(
            'innerLayout.balanceTransfers.balance.instantSettlement.banner.title'
          )}
        </p>
        <p className={styles['instant-settlement__banner-content-subtitle']}>
          {t(
            'innerLayout.balanceTransfers.balance.instantSettlement.banner.description'
          )}
        </p>
      </div>
    </div>
  );
};

export default Banner;
